export const environment = {
  production: true,
  projectName: "SafeCloud",
  apiUrl: "/api/",
  logo: "",
  key: "uNcP9e7jsE0x0T9VExv2ag==",

  CLIENT_ID: "659d4487-a564-455a-a6df-e4a29d9aa22b",
  SCOPES: "https://singlarinnovacion.com/SafeCloud_Protection/Authentication",
  TENANT: "https://login.microsoftonline.com/common", //"https://login.microsoftonline.com/4c115cdc-7eae-4e8e-b575-e581a0383d13",
  REDIRECT_URI: "/ms-auth",
  //Developer Information
  company: "Singlar Innovación",
  website: "www.safecloudsinglar.com",
  mailAddress: "hello@safecloudsinglar.com",
  copyright:
    "Copyright © 2023 <b><a href='https://safecloudsinglar.com' target='_blank'>SafeCloud Singlar</a></b> - All Rights Reserved.",
  socialFacebook: "",
  SocialTwitter: "",
};
